/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAppAction } from "../appAction";
import { nichesActions } from "./niches-action";
import { getDefaultNichesState, INichesState } from "./niches-state";

const handlers = {
  [nichesActions.FETCH_NICHES]: (
    state: INichesState
  ): INichesState => {
    return { ...state, loading: true };
  },
  [nichesActions.FETCH_NICHES_SUCCESS]: (
    state: INichesState,
    niches: any
  ): INichesState => {
    return { ...state, niches: niches, loading: false, error: null };
  },
  [nichesActions.FETCH_NICHES_ERROR]: (
    state: INichesState,
    error: Error
  ): INichesState => {
    return { ...state, error: error, loading: false };
  },
  [nichesActions.ADD_TO_NICHE]: (
    state: INichesState
  ): INichesState => {
    return { ...state, loading: true };
  },
  [nichesActions.ADD_TO_NICHE_SUCCESS]: (
    state: INichesState
  ): INichesState => {
    return { ...state, loading: false, error: null };
  },
  [nichesActions.ADD_TO_NICHE_ERROR]: (
    state: INichesState,
    error: Error
  ): INichesState => {
    return { ...state, loading: false, error: error };
  },
};

export const nichesReducer = (
  state: INichesState = getDefaultNichesState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) : state;
};
